import { CartEmptyIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './CartBadge.module.css.mjs';
import { iconMap } from './CartBadge.utils.mjs';

const CartBadge = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, digit, thickness = "default", withBoundingBox = true, textColor, ...rest } = props;
    const digitString = digit?.toString();
    const classNames = clsx("kohler-cart-badge-root", className, classes.cartBadgeRoot);
    const Icon = digitString && digitString !== "0" ? iconMap[thickness][digitString.length || 0] : CartEmptyIcon;
    return /* @__PURE__ */ React.createElement(Box, { className: classNames, component, ref, textColor: textColor || "var(--content-secondary)", ...rest }, /* @__PURE__ */ React.createElement(Icon, { withBoundingBox }), digitString && digitString !== "0" && /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.cartLabelWrapper, digitString.length > 2 && classes.cartLabelWrapperLong) }, /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "tag-s", className: classes.cartLabel, textColor: textColor || "var(--content-secondary)" }, digitString)));
  }
);

export { CartBadge };
